module.exports = __webpack_public_path__ + "img/y_2007.43ac5108.png";